import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const stageClass = (stage) => {
  if (!stage) return "stage-cold-lead";
  // convert "Hot - Agreement Pending" -> "stage-hot-agreement-pending"
  const slug = stage.toLowerCase().replace(/\s*-\s*/g, "-").replace(/\s+/g, "-");
  return `stage-${slug}`;
};

export const formatDate = (iso) => {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" });
  } catch {
    return iso;
  }
};

export const formatDateTime = (iso) => {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleString("en-US", { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch {
    return iso;
  }
};

export const initials = (name) => {
  if (!name) return "??";
  return name.split(/[\s,]+/).filter(Boolean).slice(0, 2).map(s => s[0]?.toUpperCase()).join("");
};
